import {useQuery} from "@tanstack/react-query";
import {RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useFetchRecommsBySector(sectorID: string) {
    const {data, error, isLoading} = useQuery({
        queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR, sectorID],
        queryFn: () => RecommendationsApi.fetchRecommendationsBySector(sectorID),
        enabled: Boolean(sectorID),
    });

    return {
        recommsSectorData: data?.data,
        recommsSectorError: error,
        recommsSectorIsLoading: isLoading,
    };
}
